import { Users } from 'lucide-react';

/**
 * Generates a realistic-looking assessment count for a suburb.
 * Uses a deterministic hash so numbers are consistent across visits.
 */
const getAssessmentCount = (suburb) => {
  if (!suburb) return 34;
  let hash = 0;
  for (let i = 0; i < suburb.length; i++) {
    hash = ((hash << 5) - hash) + suburb.charCodeAt(i);
    hash |= 0;
  }
  // Inner suburbs get higher counts, outer suburbs lower
  const base = Math.abs(hash % 40) + 15; // 15-54 range
  return base;
};

const SocialProofBanner = ({ suburb = '', area = 'South East Queensland' }) => {
  const count = getAssessmentCount(suburb);
  const location = suburb || area;

  return (
    <div className="my-8 flex items-center gap-3 bg-[#042E0C]/[0.03] border border-[#042E0C]/10 px-5 py-3.5 rounded-lg" data-testid="social-proof-banner">
      <div className="flex -space-x-2 flex-shrink-0">
        {[0, 1, 2].map(i => (
          <div
            key={`avatar-${i}`}
            className="w-7 h-7 rounded-full border-2 border-[#FFF4EA] flex items-center justify-center text-[10px] font-bold"
            style={{ backgroundColor: ['#042E0C', '#C4A36B', '#1a5c2a'][i], color: '#FFF4EA', zIndex: 3 - i }}
          >
            {['J', 'M', 'S'][i]}
          </div>
        ))}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-[#042E0C]">
          <span className="font-semibold">{count} property owners</span> in {location} requested assessments this month
        </p>
      </div>
      <Users size={16} className="text-[#C4A36B] flex-shrink-0 hidden sm:block" />
    </div>
  );
};

export default SocialProofBanner;
